import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { RbacService } from '../../core/services/rbac.service';

export const landingRedirectGuard: CanActivateFn = () => {
  const rbacService = inject(RbacService);
  const router = inject(Router);
  const isBankerIQEnabled = environment.featureToggles.enableBankerIQ;

  return rbacService.getUserAccess().pipe(
    map((accessRights) => {
      // Logic to determine landing page based on API response
      if (isBankerIQEnabled && accessRights.bankerIQAuthorizationStatus) {
        return router.createUrlTree(['/banker-iq/0/edit']);
      }
      if (accessRights.valueChainViewerAuthorizationStatus) {
        return router.createUrlTree(['/home']);
      }
      if (accessRights.businessInputAuthorizationStatus) {
        return router.createUrlTree(['/business-input']);
      }
      // Default landing page
      return router.createUrlTree(['/login-failed']);
    }),
    catchError(() => {
      // Fallback if API fails or user lacks permissions
      return of(router.createUrlTree(['/login-failed']));
    }),
  );
};
